import React from "react";
import "components/Dashboard/styles/BureauVeritasPortal.css";

const cellStyle = { fontSize: "0.95rem" };
const headerRowStyle = { fontSize: "0.95rem" };

const SupportPage = () => (
  <main className="page-shell" style={{ marginTop: "190px" }}>
    <section className="page-hero">
      <div className="container text-center">
        <h1 className="portal-title mb-3">Support & Contact</h1>
        <p className="portal-intro text-start">Need assistance? Let’s connect.</p>
        <p className="portal-intro text-start">
          For questions or support, please contact the appropriate team below:
        </p>
      </div>
    </section>

    <section className="container pb-4">
      <div className="content-card">
        <div className="row g-4">
          <div className="col-12">
            <div className="table-wrap">
              <table className="portal-table">
                <thead>
                  <tr style={headerRowStyle}>
                    <th>Support Area</th>
                    <th>Use For</th>
                    <th>Contact</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={cellStyle}>Lab Resources</td>
                    <td style={cellStyle}>
                      Digestion methods, application guidance, and technical questions
                    </td>
                    <td>
                      <div className="contact-lines">
                        <a href="mailto:ladoig@coldblock.ca">ladoig@coldblock.ca</a>
                        <a href="mailto:mpalomba@coldblock.ca">mpalomba@coldblock.ca</a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>Product Support</td>
                    <td style={cellStyle}>Maintenance and operational support</td>
                    <td>
                      <div className="contact-lines">
                        <a href="mailto:info@coldblock.ca">info@coldblock.ca</a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>Purchase Inquiries</td>
                    <td style={cellStyle}>Pricing and ordering information</td>
                    <td>
                      <div className="contact-lines">
                        <a href="mailto:kathy.moffatt@coldblock.ca">kathy.moffatt@coldblock.ca</a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>Portal Support</td>
                    <td style={cellStyle}>
                      Access issues or technical assistance with this portal
                    </td>
                    <td>
                      <div className="contact-lines">
                        <a href="mailto:portalsupport@armadawebsolutions.com">
                          portalsupport@armadawebsolutions.com
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default SupportPage;
